var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFrenchFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "8 8 12 12"
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#V+7Ct+__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "V+7Ct+__b",
  width: 12,
  height: 12,
  x: 8,
  y: 8,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 8,
  y: 8,
  fill: "#D9D9D9",
  rx: 4
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#V+7Ct+__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0055A4",
  d: "M8 8h4v12H8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 8h4v12h-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF4135",
  d: "M16 8h4v12h-4z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "V+7Ct+__a",
  width: 28,
  height: 28,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2639_74260"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2639_74260",
  result: "shape"
})))));
export default SvgFrenchFlag;